import { CardItem } from '@/components/v3/atoms/card/card'
import { format } from 'date-fns'

export type RelatedArticlesSliderItem = {
  id: number
  title: string | null
  path: string | null
  published_date?: Date | string | null
  article_subcategories?: { name: string } | null
  article_categories?: { name: string } | null
  hero_image_ref?: { url: string | null; alt: string | null } | null
}

export function mapArticleToCardProps(
  articles?: RelatedArticlesSliderItem[]
): CardItem[] | undefined {
  return articles?.map((article) => ({
    id: article.id,
    title: article.title || '',
    path: article.path || '',
    date: article.published_date
      ? format(article.published_date, 'dd.MM.yyyy')
      : '',
    category:
      article.article_subcategories?.name ||
      article.article_categories?.name ||
      '',
    location: '',
    imageUrl: article.hero_image_ref?.url || '',
    imageAlt: article.hero_image_ref?.alt || '',
  }))
}
